// PopupModal.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CSSProperties } from 'react';
import { useLocation } from 'react-router-dom';
import ContentAlertModel from '../components/ContentAlertModel';

interface PopupModalProps {
    show: boolean;
    log:string;
    showLog:any;
    onClose: () => void;
    navigateToSmilator: () => void;
    message?: string;
    statusMessege?: string;
    navigatePath: string;
    leadId: string;
    goToSimulator?: (e: string) => void;
    onEdit?: (e: string) => void;
    productionData: any;
}



const OfferProductionResponseModel: React.FC<PopupModalProps> = ({ show,showLog,log, onClose, navigateToSmilator, message = '', statusMessege, navigatePath, leadId, goToSimulator, onEdit, productionData }) => {
    const location = useLocation();
    console.log("location.pathname === '/Leads'", location.pathname === '/Leads')
    console.log("location.pathname", location.pathname);
    const navigate = useNavigate();


    useEffect(() => {
        if (message === "המידע נשמר בהצלחה") {
            console.log('message', message);

            // const timer = setTimeout(() => {
            //     console.log('Navigating to /Leads');
            //     navigate('/Leads');
            // }, 2000);

            // Cleanup function to clear timeout if message changes or component unmounts
            //return () => clearTimeout(timer);
        }
    }, [message, navigate]);


    

    const gotoSimulatorFunc = () => {
        localStorage.setItem('leadId', leadId)
        if (goToSimulator) {
            goToSimulator(leadId)
        }
        navigate('/Simulator');
    }

    const goToLead = () => {
        if (onEdit) {
            onClose();
            navigateToSmilator();
            onEdit(leadId);
        }
    }
    // Close modal when clicking outside the content
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const navigateToLeadFromSimulator = () => {
        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
            savedFilter.searchText =productionData.ownerFirstName + " " + productionData.ownerLastName;
            localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
        }
        navigate('/Leads');
    }


    if (!show) return null; // Return null if the modal should not be shown

    return (
        <div
            onClick={handleOverlayClick}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 300,
                    height: 200,
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                {/* create messege for success from server */}
                {statusMessege === 'שגיאה' ? (<p style={{ color: 'red', fontSize: 24 }}>{message}</p>) :
                    statusMessege !== 'התראה' ? (<p style={{ color: 'blue', fontSize: 24 }}>{message}</p>)
                        : navigatePath === 'simulator' ?
                            (

                                <ContentAlertModel
                                    message={message + " יש לבצע חישוב מחדש בסימולטור."}
                                    onClose={onClose}
                                    navigateFromLead={gotoSimulatorFunc}
                                    navigateFromOffers={() => navigateToSmilator()}
                                    navigatePath={navigatePath}
                                // toLeads={() => toLeads()}
                                />

                            ) :
                            (
                                <ContentAlertModel
                                    message={message + "יש לעדכן את הליד ובעלות רכב בהתאמה"}
                                    onClose={onClose}
                                    navigateFromLead={goToLead}
                                    navigateFromOffers={navigateToLeadFromSimulator}
                                    navigatePath={navigatePath}
                                // toLeads={() => toLeads()}
                                />
                            )
                }

                < button onClick={(e: any) => onClose()} className="button blue" >
                    סגור 
                </button>
            </div>
        </div>
    );
};



export default OfferProductionResponseModel;